<script lang="ts">
	import { format } from 'svelte-i18n';
	import { FlexibleCard, Icon } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { getXT1TemplateStatus } from 'src/helpers/xt1_helpers/template_status_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	let className = '';
	export { className as class };

	export let device: Device;

	$: statuses = getXT1TemplateStatus(device.id);
</script>

<FlexibleCard
	backgroundColor={$showNewLayout ? '--color-0' : undefined}
	padding="m"
	class={className}
	header={$format('live_time_energy', { default: 'Livetime energy' })}
	icon="far fa-circle-bolt"
>
	{statuses.find((i) => i.name == 'total_act_energy')?.value || 'N/A'}
	<Icon icon="far fa-bolt" class="text-success mt-s" size="m" slot="right" />
</FlexibleCard>
